import React, {useMemo} from 'react';
import AurPizzaTrackerProgress, {
  DataSetReportStatusItem,
  STEP_PROCESSING_STATUS,
} from '../../../common/aur-pizza-traker-progress/AurPizzaTrackerProgress';
import {t} from 'i18next';

const ProjectCreationStepsCaptionMap: {[key: string]: string} = {
  InitiateEngagement: 'initiateEngagement',
  HostingWorkspace: 'hostingWorkspace',
  InfraStructureProvisioned: 'infrastructureProvisioned',
  SyncingToArora: 'syncingToArora',
};

type ProgressStepType =
  | 'InitiateEngagement'
  | 'HostingWorkspace'
  | 'InfraStructureProvisioned'
  | 'SyncingToArora';

interface ProgressStepDetailType {
  status: STEP_PROCESSING_STATUS;
  startDate?: string;
  completeDate?: string;
}
export interface ProjectCreationProgressDataType {
  initiateEngagement?: ProgressStepDetailType;
  hostingWorkspace?: ProgressStepDetailType;
  infraStructureProvisioned?: ProgressStepDetailType;
  syncingToArora?: ProgressStepDetailType;
}
interface Props {
  progressType: 'new-project-created' | 'created-project-progress';
  progressData?: ProjectCreationProgressDataType;
}
const stringPath = 'projectCreation.pizzaTracker.';

const ProjectCreationProgressTracker: React.FC<Props> = ({
  progressType,
  progressData,
}) => {
  const projectProcessData = useMemo((): DataSetReportStatusItem[] => {
    const defaultData: DataSetReportStatusItem[] = [
      {
        status: 'InitiateEngagement',
        stepProcessingStatus: 'NotStarted',
        statusLabel: t(
          stringPath + `${ProjectCreationStepsCaptionMap.InitiateEngagement}`
        ),
        errorLabel: '',
      },
      {
        status: 'InfraStructureProvisioned',
        stepProcessingStatus: 'NotStarted',
        statusLabel: t(
          stringPath +
            `${ProjectCreationStepsCaptionMap.InfraStructureProvisioned}`
        ),
        errorLabel: '',
      },
      {
        status: 'HostingWorkspace',
        stepProcessingStatus: 'NotStarted',
        statusLabel: t(
          stringPath + `${ProjectCreationStepsCaptionMap.HostingWorkspace}`
        ),
        errorLabel: '',
      },
      {
        status: 'SyncingToArora',
        stepProcessingStatus: 'NotStarted',
        statusLabel: t(
          stringPath + `${ProjectCreationStepsCaptionMap.SyncingToArora}`
        ),
        errorLabel: '',
      },
    ];

    if (progressType === 'new-project-created') {
      defaultData[0] = {
        ...defaultData[0],
        stepProcessingStatus: 'InProgress',
        startDate: new Date().toString(),
      };
    } else if (progressType === 'created-project-progress') {
      const updateData = defaultData.map((item) => {
        let objToAdd;
        switch (item.status as ProgressStepType) {
          case 'InitiateEngagement':
            objToAdd = progressData?.initiateEngagement;
            break;
          case 'HostingWorkspace':
            objToAdd = progressData?.hostingWorkspace;
            break;
          case 'InfraStructureProvisioned':
            objToAdd = progressData?.infraStructureProvisioned;
            break;
          case 'SyncingToArora':
            objToAdd = progressData?.syncingToArora;
            break;
          default:
            break;
        }
        if (objToAdd) {
          return {
            ...item,
            stepProcessingStatus: objToAdd.status as STEP_PROCESSING_STATUS,
            startDate: objToAdd.startDate,
            completeDate: objToAdd.completeDate,
            errorLabel:
              objToAdd.status === 'Failed'
                ? t(stringPath + 'failedToLoad')
                : '',
          };
        }
        return item;
      });
      return updateData;
    }
    return defaultData;
  }, [t, progressType, progressData]);
  return <AurPizzaTrackerProgress progressSteps={projectProcessData} />;
};

export default ProjectCreationProgressTracker;
